<template>
  <div class="border border-border-secondary rounded-xl bg-quaternary overflow-hidden hover:shadow-lg transition-shadow duration-200">
    <!-- Content Section -->
    <div class="p-4 flex flex-col gap-1">
      <!-- Make and Model Title -->
      <div class="flex flex-col gap-1">
        <div class="text-xl font-bold text-primary">
          {{ model.make }} {{ model.model }}
        </div>
      </div>

      <!-- Optional: Show body style as a chip -->
      <div
        v-if="model.bodyStyle"
        class="flex items-center gap-1 mt-1"
      >
        <Chip
          size="sm"
          :rounded="false"
          outlined
        >
          {{ model.bodyStyle }}
        </Chip>
      </div>
    </div>

    <!-- Image Section -->
    <div class="relative w-full flex items-center justify-center px-2">
      <img
        :src="imageUrl"
        :alt="`${model.make} ${model.model}`"
        class="w-full h-full object-contain -my-6 -mt-10"
        @error="onImageError"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

// components
import Chip from '@/components/chip/Chip.vue'

/**
 * Props for VehicleModelCard component
 */
const props = defineProps({
  /**
   * Vehicle model data
   * @type {Object}
   * @property {number} id - Model ID
   * @property {string} make - Manufacturer name
   * @property {string} range - Vehicle range
   * @property {string} model - Model name
   * @property {string} classification - Vehicle classification
   * @property {string} bodyStyle - Body style
   * @property {string|null} image - Image URL
   */
  model: {
    type: Object,
    required: true
  }
})

// State
const imageError = ref(false)

/**
 * Default image URL
 */
const defaultImageUrl = 'https://cdn.retainauto.com/img/vehicles/default.svg'

/**
 * Computed property for image URL with fallback to default
 */
const imageUrl = computed(() => {
  if (imageError.value || !props.model.image) {
    return defaultImageUrl
  }
  return props.model.image
})

/**
 * Handle image load error
 */
function onImageError() {
  imageError.value = true
}
</script>

<style scoped></style>
